import { lazy } from 'react';
import { PlatformTypes } from '@/types/gql.generated';
import { useAlwaysAvailable } from '../addToCalendar/destinations/availability.lib';
import type { DestinationModule } from '../addToCalendar/destinations/types';

// Drawer bodies mount only once a drawer opens, so they load lazily
// (interaction registry precedent) and the entry stays cheap for data-only
// consumers.
const SaveEventDrawer = lazy(() =>
  import('./components/SaveEventDrawer').then((module) => ({
    default: module.SaveEventDrawer,
  }))
);

const BulkExportDrawer = lazy(() =>
  import('./components/BulkExportDrawer').then((module) => ({
    default: module.BulkExportDrawer,
  }))
);

// Sync without an integration: pages/planners hold live references to the same
// events (statusSource 'experienceMembership'), while schedule destinations
// create detached copies the persisted local-add store tracks. The only
// destination that can't be the pinned preferred platform.
export const agendaHeroDestination: DestinationModule = {
  platform: PlatformTypes.AgendaHero,
  behavior: 'sync',
  name: 'Agenda Hero',
  shortName: 'Agenda',
  addLabel: 'Add to Agenda Hero',
  description:
    'Changes to this schedule update your Agenda Hero calendar immediately. This includes new events added.',
  syncKind: 'live',
  icon: { kind: 'logo' },
  isPinnable: false,
  addsAllAsFeed: true,
  persistedByServer: true,
  statusSource: 'experienceMembership',
  useIsAvailable: useAlwaysAvailable,
  ExportForm: SaveEventDrawer,
  BulkExportDrawer,
};
